require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-asos-online-empire.json") })
        }
      }, "path---blog-asos-online-empire");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-asos-online-empire!./.cache/json/blog-asos-online-empire.json
// module id = 426
// module chunks = 231608221292675